export const Logo = ({ className = "h-10 w-auto", full = false }) =>
  full ? (
    <img src="/images/logo-480.webp" alt="Young Spine Tricity logo" width="480" height="480" className={className} />
  ) : (
    <img src="/images/logo-lockup.webp" alt="Young Spine Tricity" width="963" height="300" className={className} />
  );
